export default {
  orderDetails: 'Order Details',
  'orderDetails.orderReference': 'Order reference: {{reference}}',
  'orderDetails.payAmount': 'Pay {{amount}}',
  'orderDetails.installmentNumber': 'Installment {{number}}',
  'orderDetails.payBefore': 'Pay before {{date}}',
  'orderDetails.paidOn': 'Paid on {{date}}',
  'orderDetails.payInFull': 'Pay in Full: {{amount}}',
  'orderDetails.purchaseDate': 'Purchase date',
  'orderDetails.paymentStatus': 'Payment Status',
  'orderDetails.orderId': 'Order ID',
  'orderDetails.paymentMethod': 'Payment option',
  'orderDetails.paymentStatus.PAID': 'Paid',
};
